<template>
  <svg class="icons" width="0" height="0">
    <symbol id="newestburger" fill="none" viewbox="0 0 32 32">
      <path d="M4 17H28" stroke="#00274F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M4 9H28" stroke="#00274F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M4 25H28" stroke="#00274F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"> </path>
    </symbol>
    <symbol id="newmessage" fill="none" viewbox="0 0 24 24">
      <path d="M7 12L16 12" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M7 8L16 8" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M7 16L16 16" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M5 21C3.89543 21 3 20.1046 3 19L3 5C3 3.89543 3.89543 3 5 3L18 3C19.1046 3 20 3.89543 20 5L20 7L23 11L20 11L20 19C20 20.1046 19.1046 21 18 21L5 21Z" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </symbol>
    <symbol id="ardown" fill="none" viewbox="0 0 10 6">
      <path d="M1 1L5 5L9 1"></path>
    </symbol>
    <symbol id="newtel" fill="none" viewbox="0 0 24 24">
      <g clip-path="url(#clip0_2577_23277)">
        <path d="M18 12C18 8.68629 15.3137 6 12 6" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M22 12C22 6.47715 17.5228 2 12 2" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M5.18016 4.81688L5.71049 4.28655L5.18016 4.81688ZM8.29143 7.92815L7.7611 8.45848L7.7611 8.45848L8.29143 7.92815ZM6.65446 11.4276L5.90454 11.4167V11.4167L6.65446 11.4276ZM8.60043 15.3974L8.0701 15.9277L8.0701 15.9277L8.60043 15.3974ZM12.5702 17.3433L12.5592 16.5934L12.5702 17.3433ZM16.0696 15.7063L15.5393 16.2367L15.5393 16.2367L16.0696 15.7063ZM19.1809 18.8176L18.6505 19.3479L19.1809 18.8176ZM19.1632 20.3909L18.6329 19.8605L18.6329 19.8605L19.1632 20.3909ZM17.0648 22.4893L17.5952 23.0196L17.5952 23.0196L17.0648 22.4893ZM16.375 22.8108L16.4236 23.5592L16.4236 23.5592L16.375 22.8108ZM5.81658 18.1812L6.34688 17.6509L5.81658 18.1812ZM1.18419 7.60903L0.435843 7.55924L1.18419 7.60903ZM1.49934 6.94207L0.969006 6.41174L1.49934 6.94207ZM3.60688 4.83453L3.07655 4.3042L3.60688 4.83453ZM4.64983 5.34721L7.7611 8.45848L8.82176 7.39782L5.71049 4.28655L4.64983 5.34721ZM7.74346 8.9711L6.3933 10.3213L7.45396 11.3819L8.80412 10.0318L7.74346 8.9711ZM5.90454 11.4167C5.89227 12.2612 6.15703 14.0146 8.0701 15.9277L9.13076 14.867C7.52731 13.2636 7.39751 11.9114 7.40438 11.4385L5.90454 11.4167ZM8.0701 15.9277C9.98317 17.8408 11.7366 18.1055 12.5811 18.0932L12.5592 16.5934C12.0864 16.6003 10.7342 16.4705 9.13076 14.867L8.0701 15.9277ZM13.6765 17.6045L15.0267 16.2543L13.966 15.1936L12.6158 16.5438L13.6765 17.6045ZM15.5393 16.2367L18.6505 19.3479L19.7112 18.2873L16.5999 15.176L15.5393 16.2367ZM18.6329 19.8605L16.5345 21.9589L17.5952 23.0196L19.6936 20.9212L18.6329 19.8605ZM16.3264 22.0624C14.3447 22.1911 10.5526 21.8561 6.34688 17.6509L5.28628 18.7116C9.84003 23.2648 14.0755 23.7117 16.4236 23.5592L16.3264 22.0624ZM6.34688 17.6509C2.17959 13.484 1.81653 9.4021 1.93253 7.65883L0.435843 7.55924C0.296019 9.66057 0.764649 14.1905 5.28628 18.7116L6.34688 17.6509ZM2.02967 7.4724L4.13721 5.36486L3.07655 4.3042L0.969006 6.41174L2.02967 7.4724ZM1.93253 7.65883C1.93575 7.6105 1.96042 7.54164 2.02967 7.4724L0.969006 6.41174C0.676996 6.70375 0.466215 7.1028 0.435843 7.55924L1.93253 7.65883ZM16.5345 21.9589C16.4653 22.0281 16.3886 22.0584 16.3264 22.0624L16.4236 23.5592C16.8815 23.5295 17.2922 23.3226 17.5952 23.0196L16.5345 21.9589ZM18.6505 19.3479C18.7761 19.4735 18.7906 19.7028 18.6329 19.8605L19.6936 20.9212C20.4145 20.2003 20.4448 19.0209 19.7112 18.2873L18.6505 19.3479ZM12.5811 18.0932C13.0499 18.0864 13.4252 17.8557 13.6765 17.6045L12.6158 16.5438C12.5871 16.5725 12.5645 16.5866 12.5529 16.5923C12.5428 16.5972 12.546 16.5936 12.5592 16.5934L12.5811 18.0932ZM6.3933 10.3213C6.14202 10.5725 5.91136 10.9479 5.90454 11.4167L7.40438 11.4385C7.40419 11.4518 7.40059 11.4549 7.4055 11.4449C7.41115 11.4332 7.42525 11.4106 7.45396 11.3819L6.3933 10.3213ZM7.7611 8.45848C7.88663 8.58401 7.90116 8.8134 7.74346 8.9711L8.80412 10.0318C9.52505 9.31082 9.55538 8.13144 8.82176 7.39782L7.7611 8.45848ZM15.0267 16.2543C15.1844 16.0966 15.4137 16.1111 15.5393 16.2367L16.5999 15.176C15.8663 14.4424 14.6869 14.4727 13.966 15.1936L15.0267 16.2543ZM5.71049 4.28655C4.97687 3.55293 3.79749 3.58326 3.07655 4.3042L4.13721 5.36486C4.29492 5.20715 4.5243 5.22168 4.64983 5.34721L5.71049 4.28655Z" fill="#F22557"></path>
      </g>
      <defs>
        <clippath id="clip0_2577_23277">
          <rect width="24" height="24" fill="white"></rect>
        </clippath>
      </defs>
    </symbol>
    <symbol id="newchatbot" fill="none" viewbox="0 0 24 24">
      <g clip-path="url(#clip0_6671_49916)">
        <path d="M4 11H3C1.89543 11 1 11.8954 1 13V14C1 15.1046 1.89543 16 3 16H4" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M20 16L21 16C22.1046 16 23 15.1046 23 14L23 13C23 11.8954 22.1046 11 21 11L20 11" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M7.5 4C8.32843 4 9 3.32843 9 2.5C9 1.67157 8.32843 1 7.5 1C6.67157 1 6 1.67157 6 2.5C6 3.32843 6.67157 4 7.5 4ZM7.5 4V7" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M8.07422 11.6186C8.22415 11.2555 8.58169 11 8.9989 11C9.41612 11 9.77366 11.2555 9.92359 11.6186" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M14 11.6186C14.1499 11.2555 14.5075 11 14.9247 11C15.3419 11 15.6994 11.2555 15.8494 11.6186" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M8 16C11 17 13 17 16 16" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M16.5 4C17.3284 4 18 3.32843 18 2.5C18 1.67157 17.3284 1 16.5 1C15.6716 1 15 1.67157 15 2.5C15 3.32843 15.6716 4 16.5 4ZM16.5 4V7" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M4 9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9V18C20 19.1046 19.1046 20 18 20H12L8 23V20H6C4.89543 20 4 19.1046 4 18V9Z" stroke="#F22557" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </g>
      <defs>
        <clippath id="clip0_6671_49916">
          <rect width="24" height="24" fill="white"></rect>
        </clippath>
      </defs>
    </symbol>
  </svg>
  <header ref="header" class="header header_new">
    <div class="wrapper-section">
      <div class="header__main"><a class="header__logo" href="./"><img class="header__desklogo" :src="logo" alt="Росбанк страхование"><img class="header__moblogo" :src="moblogo" alt="Росбанк страхование"></a>
        <button class="header__burger showtrigger" data-toggle=".header__nav" data-in=".header__main">
          <svg viewBox="0 0 32 32">
            <use href="#newestburger"></use>
          </svg>
        </button>
        <nav class="header__nav" aria-label="site navigation">
          <ul>
            <li class="navlink navlink_new"><a class="navlink__link trigger" href="./" data-toggle="self" data-oneof="navlink">О компании
                <svg viewBox="0 0 10 6">
                  <use href="#ardown"></use>
                </svg></a>
              <ul class="navlink__list">
                <li class="navlink__sublink"><a href="./">Группа Societe Generale</a></li>
                <li class="navlink__sublink"><a href="./">Руководство</a></li>
                <li class="navlink__sublink"><a href="./">Социальная ответственность</a></li>
                <li class="navlink__sublink"><a href="./">Финансовые показатели</a></li>
                <li class="navlink__sublink"><a href="./">Раскрытие информации</a></li>
                <li class="navlink__sublink"><a href="./">Работа в Росбанке</a></li>
                <li class="navlink__sublink"><a href="./">Контакты</a></li>
              </ul>
            </li>
            <li class="navlink navlink_new"><a class="navlink__link" href="./">Программы страхования</a>
            </li>
            <li class="navlink navlink_new"><a class="navlink__link trigger" href="./" data-toggle="self" data-oneof="navlink">Связаться с нами
                <svg viewBox="0 0 10 6">
                  <use href="#ardown"></use>
                </svg></a>
              <ul class="navlink__list">
                <li class="navlink__sublink"><a class="navlink__flexlink" href="./">
                    <svg viewBox="0 0 24 24">
                      <use href="#newmessage"></use>
                    </svg>
                    <div class="navlink__flexlink-content">
                      <div class="navlink__flexlink-title">Создать обращение</div>
                      <div class="navlink__flexlink-subtitle">по&nbsp;любым&nbsp;вопросам страхования</div>
                    </div>
                  </a></li>
                <li class="navlink__sublink"><a class="navlink__flexlink" href="./">
                    <svg viewBox="0 0 24 24">
                      <use href="#newchatbot"></use>
                    </svg>
                    <div class="navlink__flexlink-content">
                      <div class="navlink__flexlink-title">Чат-бот</div>
                      <div class="navlink__flexlink-subtitle">ответы на частые вопросы</div>
                    </div>
                  </a></li>
                <li class="navlink__sublink"><a class="navlink__flexlink" href="./">
                    <svg viewBox="0 0 24 24">
                      <use href="#newtel"></use>
                    </svg>
                    <div class="navlink__flexlink-content">
                      <div class="navlink__flexlink-title">8 800 700 7 333</div>
                      <div class="navlink__flexlink-subtitle">центр поддержки клиентов</div>
                    </div>
                  </a></li>
              </ul>
            </li><a class="langlink header__langlink" href="./">En</a><a class="newbtn newbtn_sm" href="./">Страховое событие</a>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data: ()=>({
    collections: [],
    logo: `data:image/svg+xml;base64,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`,
    moblogo: `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjQzNDYgMEw3IDIuMjQ2ODVWNy4zNDQyNkwyNC40MzQ2IDUuODExMzZWMFoiIGZpbGw9IiNGMjI1NTciLz4KPHBhdGggZD0iTTE3LjY3NTcgMTAuMjU3OEMxNS41MzIzIDEwLjI5NjkgMTMuNDkxNyAxMS4xODI5IDEyLjAwMDYgMTIuNzIyMVYxMC42MTU5SDdWMzEuOTk5NEgxMS45NjlWMjQuNDAxMkMxMy40Njc3IDI1LjkzNTkgMTUuNTE0MSAyNi44MTQ1IDE3LjY1OTkgMjYuODQ0NEMyMi4zNjU0IDI2Ljg0NDQgMjQuOTQ3NCAyNC4yOTA2IDI0Ljk0NzQgMTguNTQ1OEMyNC45NDc0IDEyLjgwMTEgMjIuMzY1NCAxMC4yNTc4IDE3LjY3NTcgMTAuMjU3OFpNMTUuODk0NiAyMi43MDA0QzEyLjkyOCAyMi43MDA0IDEyLjAwMDYgMjEuNjQ3MyAxMi4wMDA2IDE4LjUxOTVDMTIuMDAwNiAxNS4zOTE4IDEyLjkyOCAxNC4zMzg2IDE1Ljg5NDYgMTQuMzM4NkMxOC44NjEzIDE0LjMzODYgMTkuNzY3NiAxNS4zOTE4IDE5Ljc2NzYgMTguNTE5NUMxOS43Njc2IDIxLjY0NzMgMTguODc3MSAyMi43MDA0IDE1Ljg5NDYgMjIuNzAwNFoiIGZpbGw9IiMwMDI3NEYiLz4KPC9zdmc+Cg==`,
  }),
  mounted() {
    {
      window.q = (sel, el = document) => el.querySelector(sel),
        window.qall = (sel, el = document) => el.querySelectorAll(sel)
      Node.prototype.on = Node.prototype.addEventListener

      var header = this.$refs.header

      let applyShadow = () => {
        if (window.scrollY)
          header.classList.add('header_withshadow')
        else
          header.classList.remove('header_withshadow')
      }

      document.addEventListener('scroll', applyShadow)
      applyShadow()
      this.initTriggers()
      this.initShowTriggers()
    }
  },
  methods: {
    initTriggers() {
      let triggers = window.qall('.trigger')

      triggers.forEach(el => {
        let oneof = el.getAttribute('data-oneof')
        let searcharea = el.getAttribute('data-in') ? el.closest(el.getAttribute('data-in')) : document.body,
          target = el.getAttribute('data-toggle')
        if (target == 'self')
          target = el
        else
          target = window.q(target, searcharea)
        if (oneof) {
          if (target.classList.contains('active')) {
            this.collections[oneof] = target
            this.collections[oneof].hide = () => {
              target.classList.remove('active');
              this.collections[oneof] = undefined
            }
          }
          el.on('click', (e) => {
            e.preventDefault()
            if (target == this.collections[oneof])
              if (el.classList.contains('only')) return
              else {
                if (el.classList.contains('navlink__link'))
                  window.q('header.header').classList.remove('listactive')
                return this.collections[oneof].hide()
              }
            if (this.collections[oneof])
              this.collections[oneof].hide()
            if (el.classList.contains('navlink__link'))
              window.q('header.header').classList.add('listactive')

            target.classList.toggle('active')
            this.collections[oneof] = target
            this.collections[oneof].hide = () => {
              target.classList.remove('active');
              this.collections[oneof] = undefined
            }
          })
        }
        else
          el.on('click', (e) => { target.classList.toggle('active'); e.preventDefault() })
      });
    },
    initShowTriggers() {
      const animationtime = 400

      function loadShowTriggers(cont = document.body) {
        let showtriggers = window.qall('.showtrigger', cont)
        showtriggers.forEach(trigger => {
          if (trigger.loaded) return
          let searcharea = trigger.getAttribute('data-in') ? trigger.closest(trigger.getAttribute('data-in')) : document.body,
            target = trigger.getAttribute('data-toggle'),
            transition = false,
            oneof = trigger.getAttribute('data-oneof')
          let shareflag = false
          if (trigger.getAttribute('data-in') == '.share')
            shareflag = true
          if (target == 'parent')
            target = trigger.parentElement
          else
            target = window.q(target, searcharea)
          const property = trigger.classList.contains('showtrigger_width') ? 'max-width' : 'max-height'
          const getproperty = (property == 'max-width') ?
            () => target.scrollWidth :
            () => target.scrollHeight
          if (!oneof) {
            trigger.on('click', (e) => {
              e.preventDefault()
              if (transition) return
              transition = true
              if (shareflag)
                searcharea.style.setProperty('min-width', searcharea.offsetWidth + 'px')
              if (target.classList.contains('active')) {
                target.style.setProperty(property, getproperty() + 'px')
                window.requestAnimationFrame(() => {
                  target.style.setProperty(property, '0px')
                  setTimeout(() => transition = false, animationtime)
                })
              }

              else {
                target.style.setProperty(property, getproperty() + 'px')
                setTimeout(() => {
                  target.style.removeProperty(property)
                  transition = false
                }, animationtime)
              }

              target.classList.toggle('active')
              if (trigger.classList.contains('self'))
                trigger.classList.toggle('active')
              if (trigger.classList.contains('area-trigger'))
                searcharea.classList.toggle('active')
              if (trigger.classList.contains('header__burger'))
                window.q('header.header').classList.toggle('active')
            })
          }
          else {
            trigger.on('click', (e) => {
              e.preventDefault()
              if (this.collections[oneof]) {
                if (this.collections[oneof] == target) {
                  if (trigger.classList.contains('navlink__link'))
                    window.q('header.header').classList.remove('listactive')
                  return this.collections[oneof].hide()
                }
                this.collections[oneof].hide()
              }

              if (trigger.classList.contains('navlink__link'))
                window.q('header.header').classList.add('listactive')

              target.classList.toggle('active')
              target.style.setProperty(property, getproperty() + 'px')
              setTimeout(() => {
                target.style.removeProperty(property)
                transition = false
              }, animationtime)
              if (trigger.classList.contains('self'))
                trigger.classList.toggle('active')
              if (trigger.classList.contains('area-trigger'))
                searcharea.classList.toggle('active')


              this.collections[oneof] = target
              this.collections[oneof].hide = () => {
                target.style.setProperty(property, getproperty() + 'px')
                if (trigger.classList.contains('self'))
                  trigger.classList.toggle('active')
                window.requestAnimationFrame(() => {
                  target.classList.toggle('active')
                  target.style.setProperty(property, '0px')
                  setTimeout(() => transition = false, animationtime)
                })
                this.collections[oneof] = undefined
              }
            })
          }
          trigger.loaded = true
        })
      }

      loadShowTriggers();
    }
  }
}
</script>

<style lang="sass" scoped>

$controlsspace: 10px

img, svg
  display: block
  vertical-align: middle

.icons
  position: absolute
  visibility: hidden

.langlink
  font-family: globalvars.$font6
  letter-spacing: globalvars.$onespacing
  color: colors.$gray7
  font-size: 14px
  padding: .5rem  
.wrapper-section
  margin: 0 auto
  max-width: globalvars.$wrapper-width
  @include since(1940px) 
    &_wide
      max-width: 1776px

  &_shift
    padding-left: 20px
  &_wide
    max-width: calc(100% - 144px)
    min-width: globalvars.$wrapper-width
  &_wide2
    max-width: 1343px
    @include from(1439px)
      max-width: calc(100% - 144px)
      min-width: globalvars.$wrapper-width
  &_1180
    max-width: 1180px
  @include from(globalvars.$tablet)
    &,&_wide
      width: globalvars.$wrapper-tablet
      max-width: 100%
      min-width: 0
  @include for-mob
    &,&_wide
      width: globalvars.$wrapper-mob


.header.header_new .header__logo, .header__logo.header__logo_new
  flex-shrink: 1
  flex-basis: 351px
  .header__moblogo
    display: none
  img
    width: 100%
    height: 100%
    object-fit: contain
    object-position: left center
  @include for-mob
    .header__desklogo
      display: none
    .header__moblogo
      display: block
    img
      object-fit: initial
      height: 32px
      width: auto  
.header
  position: sticky
  top: 0
  z-index: 1000001
  transition-property: z-index, box-shadow
  transition-delay: .35s, 0s
  transition-duration: 0s, .3s
  &.active, &.listactive
    transition-delay: 0s
  &.listactive.header_tabstuck
    box-shadow: none
  box-shadow: 0 0 15px rgba(0,0,0,0)
  &_withshadow
    box-shadow: 0 0 15px rgba(0,0,0,.1)
  &.header_tabstuck
    box-shadow: none
  background: colors.$mainbg
  font-family: globalvars.$font6  

  &__support
    flex-shrink: 0
    margin-left: auto
    text-align: center
    letter-spacing: globalvars.$onespacing
  &__langlink, &__langlinkmob
    margin-right: 14px
  
  &__langlink
    &_ordered
      order: 5
    &_alt
      margin-left: 9px
      margin-right: -8px
      align-self: flex-end
    @include for-mob
      display: none
  &__langlinkmob
    display: none
    @include for-mob
      display: block
      transform: translateY(2px)
      margin-left: auto
    @include from(500px)
      margin-right: 5px
      padding: 5px

  &__lang
    margin-top: -4px
    display: block
    &:not(:first-child) >a
      position: relative
      &::before
        position: absolute
        left: 0
        bottom: 0
        content: ''
        height: 10px
        width: 1px
        background: colors.$langdivide
    >a
      letter-spacing: globalvars.$letspacing
      font-family: globalvars.$font2
      font-size: 11px
      display: block
      color: colors.$gray7
      padding: 0 $controlsspace
    &.active>a
      color: colors.$red
  
  &__main
    padding: 22px 0
    display: flex
    align-items: center
  &__logo
    padding: 0
    @include for-mob
      width: 200px
      img
        width: 100%
        height: auto
      
    img
      width: 270px
      height: 44px
    &_2 img
      width: 174px !important
      height: 46px
      
  &__nav
    margin-left: auto
    flex-grow: 1
    margin-left: 1rem
    transform: translateY(1px)
    transition: max-height .4s ease-out
    @include since(768px)
      max-height: initial !important
    @include for-mob
      overflow: hidden
      &:not(.active)
        max-height: 0
    >ul
      position: relative
      display: flex
      justify-content: flex-end
      align-items: center
      .navlink:not(:last-child)
        margin-right: 2px
      @include for-mob()
        display: block
        margin-right: auto
  &__burger
    display: none
    @include for-mob()
      display: block
      cursor: pointer
      padding: .25rem .75rem
      svg
        width: 20px
  &_alt
    @include for-mob
      .header__main
        padding: 15px 0
      .header__langlinkmob
        display: none !important
      .header__burger
        padding: 0
        &, svg
          width: 32px
          height: 32px
    @include from(500px)
      .header__logo 
        max-width: calc(100% - 85px)

  @include from(1135px)
    &__logo, &__nav
      transform: none
    &__nav>ul
        margin-top: .5rem
    &__main
      flex-wrap: wrap
      justify-content: space-between
      &_nowrap
        flex-wrap: nowrap
    &__nav
      width: 100%
      margin-left: 0
      transform: translateY(10px)
      >ul
        width: fit-content
        padding-right: 17px
        max-width: 100%
        margin-left: auto
        justify-content: flex-start
        @include for-mob
          padding-right: 0
  @include for-mob
    &.active
      box-shadow: 0 0 15px rgba(0,0,0,.1) !important        
  @include from(500px)
    &__logo
      max-width: calc(100% - 100px)
      &_less
        max-width: calc(100% - 135px)
    &__logo img
      width: 100%
      height: auto  
  
.header.header_new  
  .header__main
    padding: 16px 0
  .header__langlink
    margin-right: 16px
    margin-left: 2px
  @include for-mob
    .header__nav>ul
      width: 100%
      margin-left: 0
    .navlink:last-of-type
      .navlink__list
        margin-bottom: 16px
    .header__burger
      padding: 0
      svg
        width: 32px
        height: 32px

.navlink
  position: relative
  &.active &__link
    color: colors.$red
  &_noarrow
    svg
      display: none !important
  &_connect:nth-child(n)
    position: static
  &_connect-phantom > svg
    display: none
  &_connect:not(&_connect-phantom):nth-child(n)
    padding: 0
    &,.navlink__link
      border-radius: 4px
      letter-spacing: globalvars.$normspacing
      &, &:hover
        color: colors.$notred
    .navlink__link>svg
      margin-left: 18px
      margin-right: -1px
    .navlink__link
      display: block
      background: colors.$red
      padding: 17px 24px
      @include for-mob
        padding: 10px 11px 7px
        &.active
          margin-bottom: 10px
  &__link
    white-space: nowrap
    display: block
    font-size: 14px
    font-weight: 400
    font-family: globalvars.$font6
    color: var(--mainfont, black)
    letter-spacing: globalvars.$onespacing
    padding: 8px 11px    
    transition: .3s ease-out
    @include between(768px, 790px)
      font-size: 13px
    svg
      width: 10px
      stroke: currentColor
      transition: .3s ease-out
      transform-origin: center center
      shape-rendering: geometricPrecision
      display: inline-block
      margin-left: .85em
      margin-right: .6em
      transform: translateY(-1px)
    &:hover
      color: colors.$red
      &::after
        border-top-color: colors.$red
    &.active
      position: relative
      z-index: 2
  &__list
    display: none
    position: absolute
    top: 100%
    left: 0
    padding: .5rem 0
    box-shadow: 0 2px 6px var(--shadows,rgba(40,36,35,.1))
    border-bottom: 4px solid colors.$red
    background-color: var(--herobg, white)
    li
      a
        transition: .3s ease-out
        letter-spacing: globalvars.$letspacing
        display: block
        line-height: 1.65
        padding: .25rem 1.5rem
        font-size: 0.9em
        font-family: globalvars.$font4
        white-space: nowrap
        &:hover
          color: colors.$red
    @include for-mob()
      box-shadow: none
      position: static
      border-top: solid 1px colors.$red
      border-bottom: solid 1px colors.$red
  &__link.active + &__list
    display: block
  &__baloon
    z-index: -1
    @include for-mob()
      z-index: 0
      position: relative
      margin: -25px
      &::after
        display: none
      &::before
        box-shadow: none
        border-bottom: none
    opacity: 0
    position: absolute
    width: 100%
    &:not(.active)
      max-height: 0
      pointer-events: none
    top: calc(100% - 15px)
    padding: 25px
    margin: 0 -10px -10px
    right: 0
    max-width: 565px
    overflow: hidden
    transition: .4s ease-out
    &::before
      position: absolute
      content: ''
      left: 10px
      top: 25px
      transition: .3s ease-out
      border-bottom: 4px solid transparent
      z-index: -1
      height: calc(100% - 50px)
      width: calc(100% - 20px)
      background-color: var(--herobg, white)
      box-shadow: 0 0 8px var(--shadows, rgb(0 0 0 / 15%))
    &.active 
      opacity: 1
      &::before
        border-color: colors.$red
      .navlink__wrapper
        opacity: 1
        transition-delay: .3s
    &::after    
      transition: .4s ease-out  
      content: ''
      width: 30px
      height: 30px
      clip-path: polygon(100% 0, 0 0, 0 100%)
      box-shadow: -8px -8px 8px -8px var(--shadows, rgb(0 0 0 / 15%))
      z-index: 11
      position: absolute
      top: 15px
      right: 12%
      background: var(--herobg, white)
      transform: rotate(45deg)
  &__wrapper
    opacity: 0
    transition: opacity .2s ease
    @include for-mob
      padding-top: 0
      padding-bottom: 0
      display: block
      box-shadow: none
    >.describedlink
      flex-basis: 50%
    display: flex
    padding: 28px 0
    right: 0
  & &__flexlink
    display: flex
    align-items: flex-start
    max-width: 280px
    white-space: normal
    svg
      flex-shrink: 0
      width: 24px
      height: 24px
      margin-right: 8px
    &-content
      min-width: 168px
    &-title
      color: colors.$brownfont
    &-subtitle
      color: colors.$gray7
    

.navlink_new
  >a>svg
    margin-left: .25em
    margin-right: 0.25em
  a:not(:hover)>svg
    color: colors.$newgray
  .navlink__list
    li a 
      letter-spacing: globalvars.$onespacing
      font-family: globalvars.$font6
      padding: 12px 40px
      color: colors.$brownfont
      font-size: 14px
      line-height: 115%
    li:last-child a
      padding-bottom: 3px
.newbtn
  display: flex
  align-items: center
  justify-content: center
  text-align: center
  font-weight: 500
  font-size: 18px
  line-height: 1.16
  background: colors.$newred
  padding: 1px 40px 0
  color: colors.$notred
  position: relative
  border-radius: 8px
  height: 56px
  font-family: globalvars.$font6
  letter-spacing: globalvars.$onespacing
  min-width: 180px
  transition: .2s ease-out
  &:hover, &:active
    background: colors.$newRedHover
  &::before
    content: ''
    position: absolute
    border-radius: 8px
    left: 0
    top: 0
    right: 0
    bottom: 0
    box-shadow: 0px 24px 24px colors.$newred
    opacity: .16
    transition: .2s ease-out
  &_sm
    font-size: 14px
    height: 47px
    padding: 1px 16px 0
    &::before
      box-shadow: 0px 8px 8px colors.$newred
  &_gray
    position: relative
    span
      position: relative
      z-index: 1
    &,&:hover, &:active
      background: colors.$moar_silver_for_the_god_of_silver2
    &::before
      box-shadow: 0px 24px 24px colors.$moar_silver_for_the_god_of_silver2
      background: rgba(0,0,0,0)
    &:hover, &:active
      &::before
        background: rgba(0,0,0,0.5)

</style>